<template>
  <node-view-wrapper class="charon-img">
    <CharonFile
      v-if="node.attrs.fileId"
      :key="node.attrs.fileId"
      :file-id="node.attrs.fileId"
      :options="{
        sizes: '100vw tablet:830px laptop:950px',
        magnify: !editor.isEditable,
      }"
      draggable="true"
      data-drag-handle
    />
  </node-view-wrapper>
</template>

<script lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'

export default {
  components: {
    NodeViewWrapper,
  },
  props: nodeViewProps,
}
</script>
